/// <reference path="./src/src_new/shared/legacy/types/remotes.d.ts" />

import React, { lazy } from "react";
import { NavigateFunction } from "react-router-dom";
export const LoginPage = lazy(() => import("@/src_new/pages/auth"));
export const Dashboard = lazy(() => import("@/src_new/pages/dashboard"));
export const Leads = lazy(() => import("@/src_new/pages/leads"));
export const PipelineAnalytics = lazy(() => import("@/src_new/pages/pipeline"));
export const Opportunity = lazy(() => import("@/src_new/pages/opportunity"));
export const OpportunityAdd = lazy(() => import("@/src_new/pages/opportunity/add"));
export const OpportunityEdit = lazy(() => import("@/src_new/pages/opportunity/edit"));
export const RFQs = lazy(() => import("@/src_new/pages/rfq"));
export const LeadDetail = lazy(() => import("@/src_new/features/leads/LeaderDetail"));
export const Policies = lazy(() => import("@/src_new/pages/policies"));
export const PolicyDetails = lazy(() => import("@/src_new/features/leads/PolicyDetailsContainer"));
export const Commissions = lazy(() => import("@/src_new/pages/commissions"));
export const CommissionsLedger = lazy(() => import("@/src_new/pages/commission-ledger/index"));
export const Payments = lazy(() => import("@/src_new/pages/payments"));
export const Tax = lazy(() => import("@/src_new/pages/tax"));
export const Knowledge = lazy(() => import("@/src_new/pages/knowledge"));
export const FormConfig = lazy(() => import("@/src_new/pages/formConfig"));
export const FormConfigDetail = lazy(
  () => import("@/src_new/features/formConfig/FormConfigDetail")
);

type SelectLOBProps = {
  navigateProp: NavigateFunction;
  urlForListLob?: string;
  baseUrl?: string;
  navigateOnSelect?: string;
};

type NewSubmissionProps = {
  navigateProp: NavigateFunction;
  quote_id?: string;
  step?: string;
  urlForQuoteList?: string;
  urlforBulkInsert?: string;
  baseUrl?: string;
  postStaticPages?: {
    id: number;
    display_name: string;
    icon: React.ComponentType<any>;
    component: React.ComponentType<any>;
    description?: string;
  }[];
  isStaticField?: boolean;
  companyName?: string;
  isQREnabled?: boolean;
};

type FormConfigEndpoints = {
  SECTION: string;
  SUB_SECTION: string;
  FIELD: string;
  RENDER_FORM: string;
};

type FormConfigListingProps = {
  navigateProp?: NavigateFunction;
  formConfigUrl?: string;
  baseUrl?: string;
  endpointTofetchList?: string;
};

type FormConfigFormProps = {
  idProp?: string;
  navigateProp?: NavigateFunction;
  formConfigUrl?: string;
  baseUrl?: string;
  endPointToConfigForm?: FormConfigEndpoints;
  isQREnabled?: boolean;
  companyName?: string;
};

// Core pages
// export const HomePage = lazy(() => import("@/pages/homepage/HomePage"));
// // export const LoginPage = lazy(() => import("@/pages/SecuredAccess/secured/LoginPage"));
// export const LoginPage = lazy(() => import("@/src_new/pages/auth/LoginPage"));
// export const Leads = lazy(() => import("@/pages/SecuredAccess/pages/leads/index"));
// export const Quotes = lazy(() => import("@/pages/SecuredAccess/pages/quotes/index"));
// export const QuoteFetchQuote = lazy(() => import("@/pages/SecuredAccess/pages/quotes/QuoteFetchQuote"))
// export const PipeLine = lazy(() => import("@/pages/SecuredAccess/pages/opportunity/index"))
// export const PipelineAnalytics = lazy(() => import("@/pages/SecuredAccess/pages/pipeline/index"))
// export const RFQs = lazy(() => import("@/pages/SecuredAccess/pages/rfq/index"))

// export const Settings = lazy(() => import("@/pages/SecuredAccess/pages/settings/index"))
// export const ApiConfiguration = lazy(() => import("@/pages/SecuredAccess/pages/apiConfig/index"))
// // export const Logs = lazy(() => import("@/pages/SecuredAccess/pages/logs-monitoring/index"));
// export const Logs = lazy(() => import("@/pages/SecuredAccess/pages/logs-monitoring/index2"));

// export const ServiceTemplate = lazy(() => import("@/pages/SecuredAccess/pages/apiConfig/form"))
// export const Insurer = lazy(() => import("@/pages/SecuredAccess/pages/Insurer/index"));
// export const Calls = lazy(() => import("@/pages/SecuredAccess/pages/callLogs/index"));
// export const Dashboard = lazy(() => import("@/pages/SecuredAccess/pages/dashboard/index"));
// // export const NotFound = lazy(() => import("@/pages/NotFound"));
// // LOBs
// export const TravelInsurance = lazy(() => import("@/pages/lob/travel/TravelInsurance"));

// export const CarInsurance = lazy(() => import("@/pages/lob/car/CarInsurance"));

// // LOB flows
// // export const TravelGetQuote = lazy(() => import("@/src_new/pages/travel-quote/TravelQuotePage"));

// export const CarGetQuote = lazy(() => import("@/src_new/pages/car-quote/CarQuotePage"));

// export const PolicyResult = lazy(() => import("@/src_new/pages/policy-result/PolicyResultPage"));

// export const TravelQuoteList = lazy(() => import("@/pages/lob/common/QuoteList"));

// export const DocumentUpload = lazy(() => import("@/pages/lob/common/DocumentUpload"));

// // Other flows
// // export const RetrievePolicy = lazy(
// //   () => import("@/pages/RetrievePolicy")
// // );
// // export const Purchase = lazy(() => import("@/pages/Purchase"));

// export const RetailDashboard = lazy(
//   () => import("@/src_new/features/retail-dashboard/RetailDashboardPage")
// );

export const SubmissionList = React.lazy(() =>
  import("logsApp/SubmissionList")
    .then((m) => {
      console.log("REMOTE MODULE:", m);

      return {
        default: m.default,
      };
    })
    .catch((e) => {
      console.error("IMPORT FAILED:", e);
      return { default: () => null };
    })
);

export const SelectLOB = lazy<React.ComponentType<SelectLOBProps>>(() =>
  import("logsApp/submissions").then((module: any) => {
    const resolvedComponent = module?.SelectLOB || module?.default?.SelectLOB || module?.default;

    return {
      default: (resolvedComponent || (() => null)) as React.ComponentType<any>,
    };
  })
);

export const NewSubmission = lazy<React.ComponentType<any>>(() =>
  import("logsApp/submissions").then((module: any) => {
    const resolvedComponent =
      module?.NewSubmission || module?.default?.NewSubmission || module?.default;

    return {
      default: (resolvedComponent || (() => null)) as React.ComponentType<any>,
    };
  })
);

export const FormConfigListing = lazy<React.ComponentType<FormConfigListingProps>>(() =>
  import("logsApp/submissions").then((module: any) => {
    const resolvedComponent = module?.FormConfigListing || module?.default?.FormConfigListing;

    return {
      default: (resolvedComponent || (() => null)) as React.ComponentType<FormConfigListingProps>,
    };
  })
);

export const FormConfigForm = lazy<React.ComponentType<FormConfigFormProps>>(() =>
  import("logsApp/submissions").then((module: any) => {
    const resolvedComponent = module?.FormConfigForm || module?.default?.FormConfigForm;

    return {
      default: (resolvedComponent || (() => null)) as React.ComponentType<FormConfigFormProps>,
    };
  })
);
